import { z } from 'zod';

export const WorkspaceSchema = z.object({
  defaultCustomNotebookLocation: z.string().optional(),
  datasources: z.object({
    catalogName: z.string(),
    bronzeSchema: z.string(),
    silverSchema: z.string(),
    goldSchema: z.string(),
    checkpointLocation: z.string().optional(),
  }),
  rules: z.object({
    checkpointLocation: z.string().optional(),
  }),
});

export type WorkspaceSchemaValues = z.infer<typeof WorkspaceSchema>;
